import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomerService } from 'src/app/services/customer.service';
import { MarinaOrderLogService } from 'src/app/services/marina-order-log.service';
import { UserService } from 'src/app/services/user.service';
import { StorageUtil } from 'src/app/utils/storage.util';

@Component({
  selector: 'app-marina-order-log',
  templateUrl: './marina-order-log.component.html',
  styleUrls: ['./marina-order-log.component.scss']
})
export class MarinaOrderLogComponent implements OnInit {

  ordersLog = [];
  filteredUsers = [];
  customersFilter: any[] = new Array();
  filter = { marinaId: 0, dateStart: new Date(), dateEnd: new Date(), userId: null, customerId: null, slingId: null, lastEmployeeName: null, orderNumber: null };

  pt = {
    firstDayOfWeek: 0,
    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
      'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar'
  };

  constructor(
    private marinaOrderLogService: MarinaOrderLogService,
    private userService: UserService,
    private customerService: CustomerService,
    private spinner: NgxSpinnerService
  ) { }

  async ngOnInit(): Promise<void> {
    const marina = StorageUtil.getMarina();
    this.filter.marinaId = marina.id;
    this.loadUsers();
  }

  async find(): Promise<void> {
    return new Promise<void>(async resolve => {
      this.marinaOrderLogService.findOrders(this.filter).subscribe({
        next: async (data) => {
          this.ordersLog = data;
          resolve();
        },
        error: async (error) => {
          console.error(error);
          resolve();
        }
      });
    });
  }


  private loadUsers(): void {
    this.userService.getMarinaUsers().subscribe(
      (data) => {
        this.filteredUsers = data.map((c) => ({ label: c.firstName.concat(' ').concat(c.lastName), value: c.id }));
        this.filteredUsers.unshift({ label: 'Todos', value: null });
      }
    );
  }

}
